import { inject } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivateFn } from '@angular/router';
import { DiscardChangesComponent } from '@core/components/discard-changes/discard-changes.component';
import { partialGrayedScreenModalConfig } from '@core/constants/modal.config';
import { FormStateService } from '@core/services/form-state.service';
import * as Util from '@core/utils';
import { map, of } from 'rxjs';

export const FormCanDeactivateGuard: CanDeactivateFn<any> = () => {
  const formStateService = inject(FormStateService);
  const dialog = inject(MatDialog);
  const bottomSheet = inject(MatBottomSheet);
  if (formStateService.hasChange) {
    if (Util.isMobile()) {
      return bottomSheet
        .open(DiscardChangesComponent, {
          panelClass: 'content_main-drawer',
          autoFocus: false,

        })
        .afterDismissed()
        .pipe(map((res) => res === true));
    } else {
      return dialog
        .open(DiscardChangesComponent, {
          ...partialGrayedScreenModalConfig,
          autoFocus: false,

        })
        .afterClosed()
        .pipe(map((res) => res === true));
    }
  }
  return of(true);
};
